import { TagT } from 'app/data/vacancy'
import { createAction } from 'typesafe-actions'

export const setActiveTag = createAction('tag->SET')<TagT | undefined>()
